import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _styled from "styled-components";
var _excluded = ["backgroundColor", "children", "isBodyCopy"];
import * as React from 'react';
import styled from 'styled-components';
import * as constants from '@latitude/core/utils/constants';
var StyledComponent = /*#__PURE__*/styled.div.withConfig({
  displayName: "Box__StyledComponent",
  componentId: "sc-1jd6gks-0"
})(["display:", ";position:", ";overflow:", ";", ";", ";", ";", ";", ";", ";", ";margin:", ";padding:", ";", ";", ";", ";", ";", ";", ";", ";", ";"], function (_ref) {
  var cssDisplay = _ref.cssDisplay;
  return cssDisplay;
}, function (_ref2) {
  var position = _ref2.position;
  return position;
}, function (props) {
  return props.cssOverflow ? props.cssOverflow : "" + props.cssOverflowX;
}, function (_ref3) {
  var hasShadow = _ref3.hasShadow;
  return hasShadow && 'box-shadow: 0 0 8px 0 rgba(0,0,0,0.1);';
}, function (_ref4) {
  var cssWidth = _ref4.cssWidth;
  return cssWidth ? "width: " + cssWidth + ";" : '';
}, function (_ref5) {
  var cssHeight = _ref5.cssHeight;
  return cssHeight ? "height: " + cssHeight + ";" : '';
}, function (_ref6) {
  var minWidth = _ref6.minWidth;
  return minWidth ? "min-width: " + minWidth + ";" : '';
}, function (_ref7) {
  var maxWidth = _ref7.maxWidth;
  return maxWidth ? "max-width: " + maxWidth + ";" : '';
}, function (_ref8) {
  var minHeight = _ref8.minHeight;
  return minHeight ? "min-height: " + minHeight + ";" : '';
}, function (_ref9) {
  var maxHeight = _ref9.maxHeight;
  return maxHeight ? "max-height: " + maxHeight + ";" : '';
}, function (props) {
  return props.cssMargin ? props.cssMargin : props.cssMarginTop + " " + props.cssMarginRight + " " + props.cssMarginBottom + " " + props.cssMarginLeft;
}, function (props) {
  return props.cssPadding ? props.cssPadding : props.cssPaddingTop + " " + props.cssPaddingRight + " " + props.cssPaddingBottom + " " + props.cssPaddingLeft;
}, function (_ref10) {
  var backgroundColor = _ref10.backgroundColor;
  return backgroundColor && "background-color: " + backgroundColor;
}, function (_ref11) {
  var borderRadius = _ref11.borderRadius;
  return borderRadius && "border-radius: " + borderRadius;
}, function (_ref12) {
  var cssDisplay = _ref12.cssDisplay,
      alignContent = _ref12.alignContent;
  return cssDisplay === 'flex' && alignContent && "align-content: " + alignContent + ";";
}, function (_ref13) {
  var cssDisplay = _ref13.cssDisplay,
      alignItems = _ref13.alignItems;
  return cssDisplay === 'flex' && alignItems && "align-items: " + alignItems + ";";
}, function (_ref14) {
  var cssDisplay = _ref14.cssDisplay,
      flexDirection = _ref14.flexDirection;
  return cssDisplay === 'flex' && flexDirection && "flex-direction: " + flexDirection + ";";
}, function (_ref15) {
  var cssDisplay = _ref15.cssDisplay,
      flexWrap = _ref15.flexWrap;
  return cssDisplay === 'flex' && flexWrap && "flex-wrap: " + flexWrap + ";";
}, function (_ref16) {
  var cssDisplay = _ref16.cssDisplay,
      justifyContent = _ref16.justifyContent;
  return cssDisplay === 'flex' && justifyContent && "justify-content: " + justifyContent + ";";
}, function (_ref17) {
  var isResponsive = _ref17.isResponsive,
      isBodyCopy = _ref17.isBodyCopy;
  return isResponsive && "\n    @media (max-width: " + constants.BREAKPOINT.SM + ") {\n      padding: 0 15px;\n    }\n    @media (min-width: " + constants.BREAKPOINT.SM + ") {\n      max-width: 540px;\n    }\n    @media (min-width: " + constants.BREAKPOINT.MD + ") {\n      max-width: 690px;\n    }\n    @media (min-width: " + constants.BREAKPOINT.LG + ") {\n      max-width: " + (isBodyCopy ? '690px' : '930px') + ";\n    }\n    @media (min-width: " + constants.BREAKPOINT.XL + ") {\n      max-width: " + (isBodyCopy ? '690px' : '1110px') + ";\n    }\n  ";
});

var Box = function Box(_ref18) {
  var id = _ref18.id,
      className = _ref18.className,
      children = _ref18.children,
      backgroundColor = _ref18.backgroundColor,
      borderRadius = _ref18.borderRadius,
      _ref18$display = _ref18.display,
      display = _ref18$display === void 0 ? constants.DISPLAY.BLOCK : _ref18$display,
      _ref18$position = _ref18.position,
      position = _ref18$position === void 0 ? constants.POSITION.STATIC : _ref18$position,
      _ref18$overflowX = _ref18.overflowX,
      overflowX = _ref18$overflowX === void 0 ? constants.OVERFLOW.VISIBLE : _ref18$overflowX,
      overflow = _ref18.overflow,
      _ref18$isResponsive = _ref18.isResponsive,
      isResponsive = _ref18$isResponsive === void 0 ? false : _ref18$isResponsive,
      _ref18$isBodyCopy = _ref18.isBodyCopy,
      isBodyCopy = _ref18$isBodyCopy === void 0 ? false : _ref18$isBodyCopy,
      _ref18$marginTop = _ref18.marginTop,
      marginTop = _ref18$marginTop === void 0 ? constants.MARGIN.M0 : _ref18$marginTop,
      _ref18$marginBottom = _ref18.marginBottom,
      marginBottom = _ref18$marginBottom === void 0 ? constants.MARGIN.M0 : _ref18$marginBottom,
      _ref18$marginLeft = _ref18.marginLeft,
      marginLeft = _ref18$marginLeft === void 0 ? constants.MARGIN.M0 : _ref18$marginLeft,
      _ref18$marginRight = _ref18.marginRight,
      marginRight = _ref18$marginRight === void 0 ? constants.MARGIN.M0 : _ref18$marginRight,
      margin = _ref18.margin,
      _ref18$paddingTop = _ref18.paddingTop,
      paddingTop = _ref18$paddingTop === void 0 ? constants.PADDING.P0 : _ref18$paddingTop,
      _ref18$paddingBottom = _ref18.paddingBottom,
      paddingBottom = _ref18$paddingBottom === void 0 ? constants.PADDING.P0 : _ref18$paddingBottom,
      _ref18$paddingLeft = _ref18.paddingLeft,
      paddingLeft = _ref18$paddingLeft === void 0 ? constants.PADDING.P0 : _ref18$paddingLeft,
      _ref18$paddingRight = _ref18.paddingRight,
      paddingRight = _ref18$paddingRight === void 0 ? constants.PADDING.P0 : _ref18$paddingRight,
      padding = _ref18.padding,
      _ref18$alignContent = _ref18.alignContent,
      alignContent = _ref18$alignContent === void 0 ? constants.ALIGN_CONTENT.STRETCH : _ref18$alignContent,
      _ref18$alignItems = _ref18.alignItems,
      alignItems = _ref18$alignItems === void 0 ? constants.ALIGN_ITEMS.STRETCH : _ref18$alignItems,
      _ref18$justifyContent = _ref18.justifyContent,
      justifyContent = _ref18$justifyContent === void 0 ? constants.JUSTIFY_CONTENT.FLEX_START : _ref18$justifyContent,
      _ref18$flexDirection = _ref18.flexDirection,
      flexDirection = _ref18$flexDirection === void 0 ? constants.FLEX_DIRECTION.ROW : _ref18$flexDirection,
      _ref18$flexWrap = _ref18.flexWrap,
      flexWrap = _ref18$flexWrap === void 0 ? constants.FLEX_WRAP.NOWRAP : _ref18$flexWrap,
      width = _ref18.width,
      height = _ref18.height,
      maxWidth = _ref18.maxWidth,
      minWidth = _ref18.minWidth,
      hasShadow = _ref18.hasShadow;
  var props = {
    id: id,
    className: className,
    children: children,
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    cssDisplay: display,
    cssOverflowX: overflowX,
    cssOverflow: overflow,
    position: position,
    isResponsive: isResponsive,
    isBodyCopy: isBodyCopy,
    cssMarginTop: marginTop,
    cssMarginBottom: marginBottom,
    cssMarginLeft: marginLeft,
    cssMarginRight: marginRight,
    cssMargin: margin,
    cssPaddingTop: paddingTop,
    cssPaddingBottom: paddingBottom,
    cssPaddingLeft: paddingLeft,
    cssPaddingRight: paddingRight,
    cssPadding: padding,
    alignContent: alignContent,
    alignItems: alignItems,
    justifyContent: justifyContent,
    flexDirection: flexDirection,
    flexWrap: flexWrap,
    cssWidth: width,
    cssHeight: height,
    maxWidth: maxWidth,
    minWidth: minWidth,
    hasShadow: hasShadow
  };
  return /*#__PURE__*/React.createElement(StyledComponent, props, children);
};

var _StyledBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Box___StyledBox",
  componentId: "sc-1jd6gks-1"
})(["padding:40px ", ";@media (min-width:", "){padding:72px ", ";}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
});

var Flex = function Flex(props) {
  return /*#__PURE__*/React.createElement(Box, Object.assign({}, props, {
    display: "flex"
  }));
};

Box.Section = function (_ref19) {
  var backgroundColor = _ref19.backgroundColor,
      children = _ref19.children,
      isBodyCopy = _ref19.isBodyCopy,
      rest = _objectWithoutPropertiesLoose(_ref19, _excluded);

  return /*#__PURE__*/React.createElement(_StyledBox, {
    backgroundColor: backgroundColor || constants.COLOR.WHITE,
    $_css: constants.PADDING.P0,
    $_css2: constants.BREAKPOINT.MD,
    $_css3: constants.PADDING.P0
  }, /*#__PURE__*/React.createElement(Box, Object.assign({
    isResponsive: true,
    isBodyCopy: isBodyCopy,
    margin: constants.MARGIN.M0 + " " + constants.MARGIN.MAUTO
  }, rest), children));
};

export { Box, Flex };